const investmentFundStatusLang = {
	open: {
		tag: 'investment.fund_status.open',
		fr: 'Ouvert',
		en: 'Open',
	},
	closed: {
		tag: 'investment.fund_status.closed',
		fr: 'Fermé',
		en: 'Closed',
	},
	liquidated: {
		tag: 'investment.fund_status.liquidated',
		fr: 'Liquidé',
		en: 'Liquidated',
	},
};

export default investmentFundStatusLang;
